import { env } from '../lib/env';

export const API_CONFIG = {
  CF_WORKER_BASE_URL: env.PRODUCT_BACKEND_URL || 'https://ecom-worker.example.com/api',
  SPRING_BOOT_BASE_URL: env.ORDER_MGMT_API_URL || 'https://ecom-api.example.com/api',
  TIMEOUT: 60000,
} as const;

export const APP_CONFIG = {
  COMPANY_NAME: env.COMPANY_NAME || 'My Ecommerce Store',
  LOGO_URL: env.LOGO_URL || '',
} as const;
